"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M20.181 4.044a1.243 1.243 0 0 1 1.704.094l.084.096c.368.468.376 1.139.016 1.613l-.083.098L9.28 19.507a1.403 1.403 0 0 1-.081.1l-.097.096-.001-.001-.009.008-.132.142a1.222 1.222 0 0 1-.93.396h-.017a1.281 1.281 0 0 1-.867-.328l-.1-.1-4.96-5.557a1.342 1.342 0 0 1 .03-1.81l.096-.09a1.245 1.245 0 0 1 1.7.09l4.084 4.246L20.085 4.135l.096-.091ZM2.15 13.93l.013.018a1.055 1.055 0 0 1-.06-.108l.047.09Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};